import { APINames } from 'src/shared';
import MacleJSBridge from 'src/bridges';

/**
 * 关闭小程序
 *
 * ```js
 *   ma.miniProgram.close()
 * ```
 */
export function close() {
  MacleJSBridge.invokeMethod(APINames.MiniProgram.CLOSE);
}
